import { RoutingModule, RoutingComponents } from './router.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy, DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatTableModule } from '@angular/material/table';
// drag and drop using material
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule, MatPaginatorIntl, MatProgressBarModule } from '@angular/material';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModuleModule } from './shared-module/shared-module.module';
import { pagesItemSharedService } from './api-module/pagesItemsShared/pagesItemsShared.service';
import { UtilitiesService } from './api-module/services/utilities/utilities.service';
import { AuthenticationServicesService } from './api-module/services/authentication/authentication-services.service';
import { TokenInterceptor } from './shared-module/token-interceptor';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageService } from './services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from "@angular/common/http";
import { AccordionModule } from 'primeng/accordion';
import { AgmCoreModule } from '@agm/core';
import {
  MatInputModule,
  MatDialogModule,
  MatProgressSpinnerModule,
  MatButtonModule,
  MatRadioModule
} from '@angular/material';
import { StoreModule } from '@ngrx/store';
import { refreshRateReducer } from './store/refresh-rate.reducer';
//import { ViewInvoiceDetailComponent } from './contracts-management/contractDeatail/view-invoice-detail/view-invoice-detail.component';
import { PaginatorI18n } from './PaginatorI18n';
import { EditSearchTermComponent } from './admin/master-data/SearchTerm/edit-searchTerm/edit-searchTerm.component';
import { MessageService } from 'primeng/api';
import { DummyRefreshComponent } from './dummy-refresh/dummy-refresh.component';

//import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';

@NgModule({
  declarations: [
    AppComponent,
    RoutingComponents,
    DummyRefreshComponent,

  ],
  imports: [
    BrowserModule,
    AccordionModule,
    BrowserAnimationsModule,
    RoutingModule,
    FormsModule,
    HttpClientModule,
    DragDropModule,
    MatCardModule,
    MatTableModule,
    ScrollingModule,
    MatInputModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDialogModule,
    MatRadioModule,
    MatProgressBarModule,
    //NgxQRCodeModule,
    AgmCoreModule.forRoot({
      apiKey: localStorage.getItem('webApiKey'),
      libraries: ['places']
    }),
    // MatDialog,
    // MatDialogRef,

    SharedModuleModule.forRoot(),
    StoreModule.forRoot({ refreshRateData: refreshRateReducer }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
      useDefaultLang: true
    }),
  ],

  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },

    UtilitiesService, MessageService, AuthenticationServicesService, pagesItemSharedService,
    DatePipe,
    {
      provide: MatPaginatorIntl, deps: [TranslateService],
      useFactory: (translateService: TranslateService) => new PaginatorI18n(translateService).getPaginatorIntl()

    }
  ],
  bootstrap: [AppComponent],

})
export class AppModule {
  constructor(
    private translateService: TranslateService,
    private languageService: LanguageService
  ) {
    this.languageService.language.subscribe(lng => {
      console.log('lng', lng);

      this.translateService.setDefaultLang(lng);
      this.translateService.use(lng);

    });
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
